import { ref } from 'vue';
import { ProductType } from '@/shared/enums';
import { useContext } from '../../../composables';

const HEVC_CODECS = [
  'video/mp4; codecs="hev1.1.6.L120.90"',
  'video/mp4; codecs="hev1.1.6.L93.90"',
  'video/mp4; codecs="hvc1.1.6.L120.B0"',
  'video/mp4; codecs="hvc1.1.6.L93.B0"',
];

export default function useMediaTypes() {
  const { $services } = useContext();
  const info = $services.resolve('info');

  const hevcPlayback = ref(false);
  const originalPlaylist = ref(undefined);

  function isCodecSupported(codec) {
    return 'MediaSource' in window && MediaSource.isTypeSupported(codec);
  }

  function isHEVCSupported(product) {
    if (product.type === ProductType.LIVE) {
      return info.platformSettings.enableLiveHEVC && HEVC_CODECS.every(isCodecSupported);
    }

    return info.platformSettings.enableVodHEVC && HEVC_CODECS.every(isCodecSupported);
  }

  function getPreferredMediaTypes(playlist, product) {
    if (!isHEVCSupported(product)) {
      return playlist;
    }

    hevcPlayback.value = true;
    originalPlaylist.value = playlist;

    return {
      ...playlist,
      file: {
        dash: playlist.file.dash_hevc || playlist.file.dash,
        hls: playlist.file.hls_hevc || playlist.file.hls,
        ss: playlist.file.ss,
      },
    };
  }

  return {
    hevcPlayback,
    originalPlaylist,
    getPreferredMediaTypes,
  };
}
